function setVideoStatus(selector) {
  const videoContainersTwWm = document.querySelectorAll(selector); // Changed to the correct class name

  videoContainersTwWm.forEach(containerTsss => {
    const video = containerTsss.querySelector('video'); // Get the video element inside the container
    if (!video) return; // If there's no video inside this container, skip it

    containerTsss.addEventListener('mouseenter', () => {
      console.log('Mouse entered');
      video.play();
    });


    containerTsss.addEventListener('mouseleave', () => {
      video.pause();
      video.currentTime = 0; // Reset the video to the start
    });
  });
}

setVideoStatus('.col-list-video-two-one');
setVideoStatus('.col-list-video-two-t');
setVideoStatus('.col-list-video-two-full-f');
setVideoStatus('.col-list-video-two-full');